export const AUTH = {
  loginForm: 'auth-login-form',
  loginEmailInput: 'auth-login-email',
  loginPasswordInput: 'auth-login-password',
  loginSubmitBtn: 'auth-login-submit',
  registerForm: 'auth-register-form',
  registerNameInput: 'auth-register-name',
  registerEmailInput: 'auth-register-email',
  registerPasswordInput: 'auth-register-password',
  registerSubmitBtn: 'auth-register-submit',
  logoutBtn: 'auth-logout-btn'
};

export const LANDING = {
  heroSection: 'landing-hero-section',
  getStartedBtn: 'landing-get-started-btn',
  loginLink: 'landing-login-link'
};

export const DASHBOARD = {
  container: 'dashboard-container',
  navBar: 'dashboard-navbar',
  logoutBtn: 'dashboard-logout-btn',
  profileLink: 'dashboard-profile-link',
  libraryLink: 'dashboard-library-link',
  discoverLink: 'dashboard-discover-link',
  connectionsLink: 'dashboard-connections-link',
  messagesLink: 'dashboard-messages-link'
};

export const PROFILE = {
  form: 'profile-form',
  bioInput: 'profile-bio-input',
  locationInput: 'profile-location-input',
  genresSelect: 'profile-genres-select',
  preferencesInput: 'profile-preferences-input',
  saveBtn: 'profile-save-btn'
};

export const LIBRARY = {
  container: 'library-container',
  addBookBtn: 'library-add-book-btn',
  bookCard: 'library-book-card',
  bookTitle: 'library-book-title',
  bookAuthor: 'library-book-author',
  deleteBookBtn: 'library-delete-book-btn'
};

export const DISCOVER = {
  container: 'discover-container',
  aiMatchBtn: 'discover-ai-match-btn',
  matchCard: 'discover-match-card',
  compatibilityScore: 'discover-compatibility-score',
  connectBtn: 'discover-connect-btn'
};

export const CONNECTIONS = {
  container: 'connections-container',
  requestCard: 'connections-request-card',
  acceptBtn: 'connections-accept-btn',
  rejectBtn: 'connections-reject-btn',
  connectedUserCard: 'connections-user-card',
  messageBtn: 'connections-message-btn'
};

export const MESSAGES = {
  container: 'messages-container',
  conversationList: 'messages-conversation-list',
  chatWindow: 'messages-chat-window',
  messageInput: 'messages-input',
  sendBtn: 'messages-send-btn',
  messageBubble: 'messages-bubble'
};

export const HOME = {
  emergentLink: 'home-emergent-link'
};
